export const PaperAirplanes = [
    {
    
     name: 'The Basic',
     imageFilename:'basicfull.webp',
     airoplane:'basic.png',
     shortInfo:'The most basic design that almost everyone has tried.',
     longInfo:"It's quick and easy to make, and it flies fairly well. This paper airplane is a little floppy, so it works better if you give it a gentle toss, not a hard throw. A good starter airplane for young kids.",
     difficulty: 'Easy',
     distance: 'time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/0/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/0/2.webp',
            stepDesc:'2. Unfold and then fold the top two corners into the center line.'
        },
       
        {
            step:'https://www.foldnfly.com/data/0/3.webp',
            stepDesc:'3. Again, fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/0/4.webp',
            stepDesc:'4. Finally, fold the edges down to meet the bottom of the body.'
        },
        {
            step:'https://www.foldnfly.com/data/0/final.webp',
            stepDesc:'Use a little tape to keep the wings together. If it tends to fly sharply upwards, stall, and then drop straight down, try bending the back of the wings down just a little bit.'
        },
     ],
     downloadprint:[
        {
            print:"https://www.foldnfly.com/data/0/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/0/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/0/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Basic Dart',
     imageFilename:'basicdartfull.webp',
     airoplane:'basicdart.png',
     shortInfo:'A basic design with decent distance and speed.',
     longInfo:'This is one of the most iconic paper airplane designs, and also one of the easiest to fold. It flies very fast, in a nice straight line. A forgiving airplane design that works well even with uneven or asymmetrical folds. The perfect starter airplane for anyone just learning.',
     difficulty: 'Easy',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/1/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/1/2.webp',
            stepDesc:'2. Unfold and then fold the top two corners into the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/1/3.webp',
            stepDesc:'3. Fold the top edges to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/1/4.webp',
            stepDesc:'4. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/1/5.webp',
            stepDesc:'5. Fold the wings down to meet the bottom edge of the planes body.'
        },
        {
            step:'https://www.foldnfly.com/data/1/final.webp',
            stepDesc:'This airplane has stiff wings, so it can tolerate fast throwing speeds. Throw it as hard as you can for maximum distance and speed.'
        },
     ],
     downloadprint:[
        {
            print:"https://www.foldnfly.com/data/1/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/1/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/1/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Stable',
     imageFilename:'stablefull.webp',
     airoplane:'stable.png',
     shortInfo:'This paper airplane has a lot of stability and can fly for a long time.',
     longInfo:'It likes to fly in big wide loops. If you slightly bend up the two flaps at the rear, you can get it to do flips and tricks.',
     difficulty: 'Easy',
     distance: 'time aloft,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/2/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/2/2.webp',
            stepDesc:'2. Unfold and then fold the top two corners into the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/2/3.webp',
            stepDesc:'3. Fold the top peak down to create a square.'
        },
        {
            step:'https://www.foldnfly.com/data/2/4.webp',
            stepDesc:'4. Fold the top two corners to the center about an inch above the downward facing point, to form a triangle shape on top and a diamond shape on bottom.'
        },
        {
            step:'https://www.foldnfly.com/data/2/5.webp',
            stepDesc:'5. Fold the downward facing point up to secure the flaps.'
        },
        {
            step:'https://www.foldnfly.com/data/2/6.webp',
            stepDesc:'6. Fold the plane in half away from you and flatten it out.'
        },
        {
            step:'https://www.foldnfly.com/data/2/7.jpg',
            stepDesc:'7. Fold the edges down to create the wide wings.'
        },
        {
            step:'https://www.foldnfly.com/data/2/final.webp',
            stepDesc:'If it has a tendency to flip upside down during flight, bend the wings so they make a Y shape when looked at head on. This dihedral angle will be more stable. Use some tape or a staple in the front to keep the fuselage together.'
        },
     ],
     downloadprint:[
        {
            print:"https://www.foldnfly.com/data/2/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/2/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/2/print_sample_2.png"
        },
     ]
    },
    {
   
     name: 'The Buzz',
     imageFilename:'buzzfull.webp',
     airoplane:'buzz.png',
     shortInfo:'This paper plane looks like a fly and it flies like one too!',
     longInfo:'Bend the tail flaps up or down to control the flight. Bend one up and one down to make it spiral!',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/3/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/3/2.webp',
            stepDesc:'2. Unfold and then fold the top two corners into the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/3/3.webp',
            stepDesc:'3. Fold the top peak down to the edge of the previous fold.'
        },
        {
            step:'https://www.foldnfly.com/data/3/4.webp',
            stepDesc:'4. Fold the upper sides to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/3/5.webp',
            stepDesc:'5. Fold the top about 1/2 inch away from you.'
        },
        {
            step:'https://www.foldnfly.com/data/3/6.webp',
            stepDesc:'6. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/3/7.jpg',
            stepDesc:'7. Fold both flaps out to create the wings. The body will be about a half inch tall.'
        },
        {
            step:'https://www.foldnfly.com/data/3/final.webp',
            stepDesc:'Use a bit of tape to keep this design from popping open in mid-flight. You can make small bends to the large triangular ailerons at the rear of the airplane to adjust it for level flight. Experiment with throwing hard and gently to see what works best for you.'
        },
     ],
     downloadprint:[
        {
            print:"https://www.foldnfly.com/data/3/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/3/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/3/print_sample_2.png"
        },
     ]
    },
    {
    
     name: 'The Sprinter',
     imageFilename:'sprinterfull.webp',
     airoplane:'sprinter.png',
     shortInfo:'This odd looking paper airplane has a large stabilizing tail fin.',
     longInfo:'The wings will flap at certain angles, so experiment with it and throw gently. This design is sensitive to asymmetries and takes some small adjustments to work well.',
     difficulty: 'Medium',
     distance: 'distance,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/4/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/4/2.webp',
            stepDesc:'2. Fold the long edge about 3/4 inch.'
        },
        {
            step:'https://www.foldnfly.com/data/4/3.webp',
            stepDesc:'3. Fold the paper in half towards you and then rotate so that the thickest point is facing up. The squared off point will be facing to the left.'
        },
        {
            step:'https://www.foldnfly.com/data/4/4.webp',
            stepDesc:'4. Fold the right side over and line it up with the left side and make a vertical crease.'
        },
        {
            step:'https://www.foldnfly.com/data/4/5.webp',
            stepDesc:'5. Fold the other side down so opposite sides meet.'
        },
        {
            step:'https://www.foldnfly.com/data/4/6.webp',
            stepDesc:'6. Now, fold one outer flap down to create the first wing. The body will be about 3/4 inch tall.'
        },
        {
            step:'https://www.foldnfly.com/data/4/7.jpg',
            stepDesc:'7. Fold the other flap down to complete the plane.'
        },
        {
            step:'https://www.foldnfly.com/data/4/final.webp',
            stepDesc:"This design is a little fussy and takes some careful adjustments to get it to fly straight and level. Don't give up! A staple in the front will keep the fuselage from popping open and will add a little weight in the right place. Try bending the trailing edges of the wings up or down to adjust how it flies. Read our article on how to steer a paper airplane for more tips."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/4/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/4/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/4/print_sample_2.png"
        },
     ]
    },
    {
    
     name: 'The Sea Glider',
     imageFilename:'seagliderfull.webp',
     airoplane:'seaglider.png',
     shortInfo:'This bird-like paper airplane resembles a seagull gliding over the ocean.',
     longInfo:'You can experiment to find your own ways to bend the wings and how much weight to add to the front.',
     difficulty: 'Medium',
     distance: 'decorative',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/5/1.webp',
            stepDesc:'1. Fold the paper diagonally.'
        },
        {
            step:'https://www.foldnfly.com/data/5/2.webp',
            stepDesc:'2. Cut off the extra piece at the bottom.'
        },
        {
            step:'https://www.foldnfly.com/data/5/3.webp',
            stepDesc:'3. Fold the closed edge over about 1 inch.'
        },
        {
            step:'https://www.foldnfly.com/data/5/4.webp',
            stepDesc:'4. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/5/5.webp',
            stepDesc:'5. Fold one of the top edges over as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/5/6.webp',
            stepDesc:'6. Repeat with the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/5/7.jpg',
            stepDesc:'7. Now, fold out one side to create one wing.'
        },
        {
            step:'https://www.foldnfly.com/data/5/8.jpg',
            stepDesc:'8. Finally, fold out the other sides to finalize the plane. Add a few staples or a paper clip to the front to give the tip some weight.'
        },
        {
            step:'https://www.foldnfly.com/data/5/final.webp',
            stepDesc:"The success of this paper airplane depends on how you fold the wings in the last few steps. If it doesn't fly well, back up two steps and try folding the wings at a slightly different angle. Experiment until you find what works best for you. Throw gently for best results. If it stalls and flops down, add more weight to the front."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/5/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/5/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/5/print_sample_2.png"
        },
     ]
    },
    {
    
     name: 'The Hunting Fight',
     imageFilename:'huntingfull.webp',
     airoplane:'hunting.png',
     shortInfo:'This straight shooting airplane has a heavy nose which helps it go fast and far.',
     longInfo:'Throw this paper airplane as hard as you want and see how far it goes.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/6/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/6/2.webp',
            stepDesc:'2. Fold the top edge down about 2 inches.'
        },
        {
            step:'https://www.foldnfly.com/data/6/3.webp',
            stepDesc:'3. Fold the top edge down again to double up the thick part.'
        },
        {
            step:'https://www.foldnfly.com/data/6/4.webp',
            stepDesc:'4. Repeat the previous step one more time.'
        },
        {
            step:'https://www.foldnfly.com/data/6/5.webp',
            stepDesc:'5. Fold the top corners away from you to the back center line.'
        },
        {
            step:'https://www.foldnfly.com/data/6/6.webp',
            stepDesc:'6. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/6/7.jpg',
            stepDesc:'7. Fold both sides down to create the wings and bend the edges up for speed.The body should be about a 1/2 inch'
        },
        {
            step:'https://www.foldnfly.com/data/6/final.webp',
            stepDesc:"For better performance, use a piece of tape on the bottom to hold the fuselage closed."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/6/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/6/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/6/print_sample_2.png"
        },
     ]
    },
    {
     
     name: 'Heavy-Nosed Plane',
     imageFilename:'heavynosedfull.webp',
     airoplane:'heavynosed.png',
     shortInfo:'A basic dart with a blunt heavy nose.',
     longInfo:'This starts off like a basic dart, but the additional folds give it more weight at the nose, allowing it to go far.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/7/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/7/2.webp',
            stepDesc:'2. Fold the top corners to the center line'
        },
        {
            step:'https://www.foldnfly.com/data/7/3.webp',
            stepDesc:'3. Fold the upper sides to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/7/4.webp',
            stepDesc:'4. Fold the peak to the bottom edge of the paper.'
        },
        {
            step:'https://www.foldnfly.com/data/7/5.webp',
            stepDesc:'5. Now, fold the peak back up about 2 1/2 inches past the top edge.'
        },
        {
            step:'https://www.foldnfly.com/data/7/6.webp',
            stepDesc:'6. Fold the peak back down to the edge of the previous crease.'
        },
        {
            step:'https://www.foldnfly.com/data/7/7.jpg',
            stepDesc:'7. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/7/8.jpg',
            stepDesc:'8. Finally, fold both sids down to create the wings.'
        },
        {
            step:'https://www.foldnfly.com/data/7/final.webp',
            stepDesc:"Experiment with the distances that you fold the tip back and forth to adjust how much weight is put into the nose. If you make the nose very heavy, you can make this airplane fly loops."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/7/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/7/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/7/print_sample_2.png"
        },
     ]
    },
    {
     
     name: 'Royal Wing',
     imageFilename:'royalwingfull.webp',
     airoplane:'royalwing.png',
     shortInfo:'A flying airfoil with almost no fuselage.',
     longInfo:'This is an advanced glider that floats slowly away from you if adjusted correctly. Read the notes at the bottom for tips.',
     difficulty: 'Hard',
     distance: 'acrobatic',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/8/1.webp',
            stepDesc:'1. Fold the sheet in half.'
        },
        {
            step:'https://www.foldnfly.com/data/8/2.webp',
            stepDesc:'2. Fold down the top right corner to the end of the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/8/3.webp',
            stepDesc:'3. Open and then repeat with the other side to get the creases shown.'
        },
        {
            step:'https://www.foldnfly.com/data/8/4.webp',
            stepDesc:'4. Next, accordion fold the center out to get this diamond shape.'
        },
        {
            step:'https://www.foldnfly.com/data/8/5.webp',
            stepDesc:'5. Fold the front two flaps up.'
        },
        {
            step:'https://www.foldnfly.com/data/8/6.webp',
            stepDesc:'6. Now, fold the flaps behind the top edge.'
        },
        {
            step:'https://www.foldnfly.com/data/8/7.jpg',
            stepDesc:'7. Fold the entire top half of the plane away from you. The peak should reach the end of the backside.'
        },
        {
            step:'https://www.foldnfly.com/data/8/8.jpg',
            stepDesc:'8. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/8/9.jpg',
            stepDesc:'9. Fold out both sides to create the wings. The body should be a 1/2 an inch.'
        },
        {
            step:'https://www.foldnfly.com/data/8/10.jpg',
            stepDesc:'10. Bend the ends of the wings up and then cut two small slits at the tail of each wing as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/8/final.webp',
            stepDesc:"This design has wide wings and a short body which makes it unsuitable for fast speeds. Throw it very gently. If the airplane tends to flip over, you may have made it too short. Unfold it and repeat step 7 above with less of the tip folded back. This will make the body longer and a bit more stable. Use the ailerons to steer the paper airplane and make sure the wings have a dihedral angle."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/8/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/8/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/8/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Gliding Plane',
     imageFilename:'glidingplanefull.webp',
     airoplane:'glidingplane.png',
     shortInfo:'This paper airplane glides for long distances and is perfect to throw from high areas.',
     longInfo:'A quick flyer. The odd folds are made to withstand the wind.',
     difficulty: 'Hard',
     distance: 'time aloft,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/9/1.webp',
            stepDesc:'1. Fold the paper in half.'
        },
        {
            step:'https://www.foldnfly.com/data/9/2.webp',
            stepDesc:'2. Bring the right corner down to meet the bottom-center of the left rectangle.'
        },
        {
            step:'https://www.foldnfly.com/data/9/3.webp',
            stepDesc:'3. Open the sheet and repeat with the other corner to get the creases shown.'
        },
        {
            step:'https://www.foldnfly.com/data/9/4.webp',
            stepDesc:'4. Open the sheet back up and accordion fold the center in.'
        },
        {
            step:'https://www.foldnfly.com/data/9/5.webp',
            stepDesc:'5. Now, fold the outer flaps to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/9/6.webp',
            stepDesc:'6. Fold the center piece up as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/9/7.jpg',
            stepDesc:"7. Take the outer points and fold them in twice so they're tucked in."
        },
        {
            step:'https://www.foldnfly.com/data/9/8.jpg',
            stepDesc:'8. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/9/9.jpg',
            stepDesc:'9. Finally, fold out the edges to complete the plane. If you want, you can give it a fancy crinkle fold as pictured.'
        },
        
        {
            step:'https://www.foldnfly.com/data/9/final.webp',
            stepDesc:"This design works best when thrown gently, slightly upwards. The fancy crinkle folded wing shown in the picture is optional, but if you get it right it can make this airplane slowly rock back and forth."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/9/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/9/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/9/print_sample_2.png"
        },
     ]
    },
    {   
     name: 'Tailed Plane',
     imageFilename:'tailedfull.webp',
     airoplane:'tailed.png',
     shortInfo:'This fun paper glider flies well and has a unique look with a long tail.',
     longInfo:'A unique design that uses one piece of paper, but cuts it into two pieces that you put back together to make one paper airplane.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/10/1.webp',
            stepDesc:'1. Fold the paper diagonally as shown. Cut off the bottom piece for later use.'
        },
        {
            step:'https://www.foldnfly.com/data/10/2.webp',
            stepDesc:"2. Fold the left corner down to the opposite corner to create an 'x' crease."
        },
        {
            step:'https://www.foldnfly.com/data/10/3.webp',
            stepDesc:'3. Next, accordion fold the sides in to create a triangle shape.'
        },
        {
            step:'https://www.foldnfly.com/data/10/4.webp',
            stepDesc:'4. Fold both bottom corners up to the peak.'
        },
        {
            step:'https://www.foldnfly.com/data/10/5.webp',
            stepDesc:'5. Now, take the extra piece that you cut off earlier and fold the top corners to the center to form an arrow.'
        },
        {
            step:'https://www.foldnfly.com/data/10/6.webp',
            stepDesc:'6. Insert the arrow into the planes body so that both peaks match up.'
        },
        {
            step:'https://www.foldnfly.com/data/10/7.jpg',
            stepDesc:"7. Next, fold the tip of the plane down to secure the inner arrow."
        },
        {
            step:'https://www.foldnfly.com/data/10/8.jpg',
            stepDesc:'8. Finally, tuck both center flaps into the top peak and then slightly crease the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/10/final.webp',
            stepDesc:"To throw this paper airplane, pinch the front from underneath until you get a good grip. The two sides will be at around 90 degrees to each other when you do this. Throw with medium force and use small adjustments of the tail to get it to fly level and straight. This glider tends to loop in circles instead of flying straight."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/10/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/10/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/10/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Star Wing',
     imageFilename:'starwingfull.webp',
     airoplane:'starwing.png',
     shortInfo:'This plane is made to have long wings and a very small body.',
     longInfo:'This is a difficult design to perfect and often doesnt work, but it looks cool and if you adjust it correctly you can get it to do some fun tricks.',
     difficulty: 'Medium',
     distance: 'acrobatic,decorative',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/11/1.webp',
            stepDesc:'1. Fold the paper in half in both directions, forming 4 equal rectangles. Unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/11/2.webp',
            stepDesc:"2. Fold the top corners to the center horizontal line."
        },
        {
            step:'https://www.foldnfly.com/data/11/3.webp',
            stepDesc:'3. Fold the peak down to the bottom edge.'
        },
        {
            step:'https://www.foldnfly.com/data/11/4.webp',
            stepDesc:'4. Fold the top corners to the bottom of each side.'
        },
        {
            step:'https://www.foldnfly.com/data/11/5.webp',
            stepDesc:'5. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/11/6.webp',
            stepDesc:'6. Fold out each side to create the wings. The body should be about a 3/4 an inch tall.'
        },
        {
            step:'https://www.foldnfly.com/data/11/7.jpg',
            stepDesc:"7. Finally, bend the wing tips up about 1/2 of an inch."
        },
        {
            step:'https://www.foldnfly.com/data/11/final.webp',
            stepDesc:"This airplane is a bit temperamental and requires some fine tuning of the ailerons to get it to perform well. Add a paper clip or small weight to the front to help. Make sure the folds are crisp and symmetrical and use a gentle toss."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/11/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/11/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/11/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Water Plane',
     imageFilename:'waterplanefull.webp',
     airoplane:'waterplane.png',
     shortInfo:'This paper airplane is made to look like a boat.',
     longInfo:'It glides through the air like a boat glides through water, slow and smooth.',
     difficulty: 'Easy',
     distance: 'time aloft,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/12/1.webp',
            stepDesc:'1. Fold the paper in half and repeat.'
        },
        {
            step:'https://www.foldnfly.com/data/12/2.webp',
            stepDesc:"2. Open the sheet and then fold down about 3 inches before the edge."
        },
        {
            step:'https://www.foldnfly.com/data/12/3.webp',
            stepDesc:"3. Fold the top two corners to the line that's closest to it."
        },
        {
            step:'https://www.foldnfly.com/data/12/4.webp',
            stepDesc:'4. Unfold and then accordion fold the top corners in.'
        },
        {
            step:'https://www.foldnfly.com/data/12/5.webp',
            stepDesc:'5. Fold the top flaps to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/12/6.webp',
            stepDesc:'6. Fold the paper in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/12/7.jpg',
            stepDesc:"7. Accordion fold the top peak in as shown."
        },
        {
            step:'https://www.foldnfly.com/data/12/8.jpg',
            stepDesc:"8. Finally, fold both sids out to create the wings."
        },
        {
            step:'https://www.foldnfly.com/data/12/final.webp',
            stepDesc:"This slow glider tends to float in big loops instead of going in a straight line. Avoid taping or closing up the front part of this paper airplane. The wide plow in the front is what makes it look like a boat and float slowly."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/12/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/12/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/12/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The UFO',
     imageFilename:'ufofull.webp',
     airoplane:'ufo.png',
     shortInfo:'This paper airplane is shaped like a flying saucer.',
     longInfo:'Its round shape allows it float slowly through the air just like a UFO.',
     difficulty: 'Medium',
     distance: 'time aloft,acrobatic',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/13/1.webp',
            stepDesc:'1. Cut out the bottom corner to round it off as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/13/2.webp',
            stepDesc:"2. Fold the top corners to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/13/3.webp',
            stepDesc:"3. Fold the peak down 2 inches before the bottom edge."
        },
        {
            step:'https://www.foldnfly.com/data/13/4.webp',
            stepDesc:'4. Fold down the top two corners about half way down each diagonal line.'
        },
        {
            step:'https://www.foldnfly.com/data/13/5.webp',
            stepDesc:'5. Now, fold the top edge down about one inch.'
        },
        {
            step:'https://www.foldnfly.com/data/13/6.webp',
            stepDesc:'6. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/13/7.jpg',
            stepDesc:"7. Finally, fold the sides out to create the long round wings. The body should be a 1/2 an inch."
        },
        {
            step:'https://www.foldnfly.com/data/13/final.webp',
            stepDesc:"This paper airplane design likes to float slowly in large circles instead of flying straight. It has stiff wings, so feel free to throw it as hard as you want."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/13/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/13/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/13/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Cross Wing',
     imageFilename:'crosswingfull.webp',
     airoplane:'crosswing.png',
     shortInfo:'This plane is small and fast, allowing it to go wherever you want.',
     longInfo:'Its size and heavy nose makes it one of the better flying paper airplanes. Bend two wingtips up and the other two down for a dramatic look.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/14/1.webp',
            stepDesc:'1. Fold the paper in half widthwise. Then fold the other direction and unfold to make a crease.'
        },
        {
            step:'https://www.foldnfly.com/data/14/2.webp',
            stepDesc:"2. Fold the top corners to the center line so that the fold goes straight to the bottom corners."
        },
        {
            step:'https://www.foldnfly.com/data/14/3.webp',
            stepDesc:"3. Now, open up the sheet and accordion fold the top corners in."
        },
        {
            step:'https://www.foldnfly.com/data/14/4.webp',
            stepDesc:'4. Fold the top corners to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/14/5.webp',
            stepDesc:'5. Fold the tip back about one inch.'
        },
        {
            step:'https://www.foldnfly.com/data/14/6.webp',
            stepDesc:'6. Fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/14/7.jpg',
            stepDesc:"7. Fold out the sides to create the wings. Fold the wing tips up or down to create stabilizers."
        },
        {
            step:'https://www.foldnfly.com/data/14/final.webp',
            stepDesc:"The wingtips in the final step can be folded either up or down depending on your preferences. Try both! Fold two of them up and two of them down for a dramatic look."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/14/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/14/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/14/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Spin Plane',
     imageFilename:'spinplanefull.webp',
     airoplane:'spinplane.png',
     shortInfo:'This is a very fun plane to fly.',
     longInfo:'If you throw it the right way, it will spin into the air',
     difficulty: 'Hard',
     distance: 'acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/15/1.webp',
            stepDesc:'1. Fold the corners down to each side and unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/15/2.webp',
            stepDesc:"2. Fold the top down so the three creases line up."
        },
        {
            step:'https://www.foldnfly.com/data/15/3.webp',
            stepDesc:"3. Fold the top two corners to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/15/4.webp',
            stepDesc:'4. Open up the entire sheet and accordion fold the sides in.'
        },
        {
            step:'https://www.foldnfly.com/data/15/5.webp',
            stepDesc:'5. Fold the bottom corners of the triangle to the peak.'
        },
        {
            step:'https://www.foldnfly.com/data/15/6.webp',
            stepDesc:'6. Now, fold the top sides of the diamond to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/15/7.jpg',
            stepDesc:"7. Unfold the diamond back to the triangle shape."
        },
        {
            step:'https://www.foldnfly.com/data/15/8.jpg',
            stepDesc:"8. Fold the top two sides in to the middle and then accordion fold the remaining parts upwards to get this shape."
        },
        {
            step:'https://www.foldnfly.com/data/15/9.jpg',
            stepDesc:"9. Fold down the peak 1 1/2 inches so it's tucked behind the flaps."
        },
        {
            step:'https://www.foldnfly.com/data/15/10.jpg',
            stepDesc:"10. Now, fold the upper sides to the back center line."
        },
        {
            step:'https://www.foldnfly.com/data/15/11.jpg',
            stepDesc:"11. Finally, fold the plan in half and fold out both wings."
        },
        {
            step:'https://www.foldnfly.com/data/15/final.webp',
            stepDesc:"This paper airplane design likes to float slowly in large circles instead of flying straight. It has stiff wings, so feel free to throw it as hard as you want."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/15/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/15/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/15/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Stunt Plane',
     imageFilename:'stuntplanefull.webp',
     airoplane:'stuntplane.png',
     shortInfo:'This paper airplane can do tricks, making it a very fun airplane to fly.',
     longInfo:'Adjust the wingtips to make it spin or flip. If you throw it the right way, it will spin into the air.',
     difficulty: 'Hard',
     distance: 'acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/16/1.webp',
            stepDesc:'1. Fold the corners down to each side and unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/16/2.webp',
            stepDesc:"2. Fold the top down so the three creases line up."
        },
        {
            step:'https://www.foldnfly.com/data/16/3.webp',
            stepDesc:"3. Fold the top two corners to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/16/4.webp',
            stepDesc:'4. Open up the entire sheet and accordion fold the sides in.'
        },
        {
            step:'https://www.foldnfly.com/data/16/5.webp',
            stepDesc:'5. Fold in the sides of the bottom layer. Note that the crease goes right through the bottom corners.'
        },
        {
            step:'https://www.foldnfly.com/data/16/6.webp',
            stepDesc:'6. Now, fold the big triangle in half away from you and then fold it back up again so a little bit is poking up.'
        },
        {
            step:'https://www.foldnfly.com/data/16/7.jpg',
            stepDesc:"7. Fold the plane in half away you."
        },
        {
            step:'https://www.foldnfly.com/data/16/8.jpg',
            stepDesc:"8. Finally, fold out the sides to create the wings. The body should be about one inch tall."
        },
      
    
        {
            step:'https://www.foldnfly.com/data/16/final.webp',
            stepDesc:"Fold the wingtips up a little bit for style if you want. This paper airplane design has difficulty going in a straight line. Embrace that flaw and enjoy the loops and twists that it takes through the air."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/16/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/16/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/16/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Square',
     imageFilename:'thesquarefull.webp',
     airoplane:'thesquare.png',
     shortInfo:'This boxy paper plane is great for gliding through the air.',
     longInfo:'Its wide stiff wings allow it to fly in a strong wind. It also likes to fly upside down.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/17/1.webp',
            stepDesc:'1. Fold the corners down to each side and unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/17/2.webp',
            stepDesc:"2. Fold the top down so the three creases line up."
        },
        {
            step:'https://www.foldnfly.com/data/17/3.webp',
            stepDesc:"3. Fold the top two corners to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/17/4.webp',
            stepDesc:'4. Open up the sheet and accordion fold the sides in.'
        },
        {
            step:'https://www.foldnfly.com/data/17/5.webp',
            stepDesc:'5. Fold up the outer points as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/17/6.webp',
            stepDesc:'6. Now, fold the peak down to the end of the triangle shape.'
        },
        {
            step:'https://www.foldnfly.com/data/17/7.jpg',
            stepDesc:"7. Fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/17/8.jpg',
            stepDesc:"8. Fold out both sides to create the wings. The body should be about a 1/2 an inch tall."
        },
        {
            step:'https://www.foldnfly.com/data/17/9.jpg',
            stepDesc:"9. Finally, cut two small flaps at the tail of each wing."
        },
      
    
        {
            step:'https://www.foldnfly.com/data/17/final.webp',
            stepDesc:"Point the flaps down and throw slightly upwards and this paper airplane will flip upside down and return to you like a boomerang. Point the flaps up and throw hard to get a nice glide through the air."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/17/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/17/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/17/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Origami Plane',
     imageFilename:'origamiplanefull.webp',
     airoplane:'origamiplane.png',
     shortInfo:'Learn how to make an origami paper airplane.',
     longInfo:'Designed by an origami expert, this paper plane flies fast and can do tricks.',
     difficulty: 'Expert',
     distance: 'time aloft,acrobatic',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/18/1.webp',
            stepDesc:'1. Fold one corner diagonally.'
        },
        {
            step:'https://www.foldnfly.com/data/18/2.webp',
            stepDesc:"2. Cut off the extra piece at the bottom and open up the paper. You should have a perfect square."
        },
        {
            step:'https://www.foldnfly.com/data/18/3.webp',
            stepDesc:"3. Rotate the sheet so that one corner is facing up and then fold in the outer corners to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/18/4.webp',
            stepDesc:'4. Fold down the peak as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/18/5.webp',
            stepDesc:'5. Lift up the peak and accordion fold the sides in to form a diamond shape.'
        },
        {
            step:'https://www.foldnfly.com/data/18/6.webp',
            stepDesc:'6. Fold the bottom half of the diamond up.'
        },
        {
            step:'https://www.foldnfly.com/data/18/7.jpg',
            stepDesc:"7. Fold in the sides of the top peak to the center."
        },
        {
            step:'https://www.foldnfly.com/data/18/8.jpg',
            stepDesc:"8. Fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/18/9.jpg',
            stepDesc:"9. Fold out both wings to complete the plane."
        },
      
    
        {
            step:'https://www.foldnfly.com/data/18/final.webp',
            stepDesc:"This paper airplane can fly really far, just not always in a straight line. Small adjustments to the wings can be made to get it to fly in loops or circles."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/18/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/18/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/18/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Eagle Eye',
     imageFilename:'eagleeyefull.webp',
     airoplane:'eagle.png',
     shortInfo:'This paper airplane was designed to resemble an eagle in flight.',
     longInfo:'If you throw it at the right angle, it will quickly shoot straight into the air just like an eagle.',
     difficulty: 'Medium',
     distance: 'decorative',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/19/1.webp',
            stepDesc:'1. Fold one corner diagonally.'
        },
        {
            step:'https://www.foldnfly.com/data/19/2.webp',
            stepDesc:"2. Cut off the extra piece at the bottom."
        },
        {
            step:'https://www.foldnfly.com/data/19/3.webp',
            stepDesc:"3. Fold the peak of the triangle over about 1.5-2 inches."
        },
        {
            step:'https://www.foldnfly.com/data/19/4.webp',
            stepDesc:'4. Take one layer and fold it in the opposite direction as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/19/5.webp',
            stepDesc:'5. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/19/6.webp',
            stepDesc:'6. Fold up one wing from the nose of the plane to the center of the tail.'
        },
        {
            step:'https://www.foldnfly.com/data/19/7.jpg',
            stepDesc:"7. Repeat step six with the other wing."
        },
        {
            step:'https://www.foldnfly.com/data/19/8.jpg',
            stepDesc:"8. Invert fold the tail of the plane down as shown. Experiment with the angle to find what works best for you."
        },
        {
            step:'https://www.foldnfly.com/data/19/9.jpg',
            stepDesc:"9. Fold out one wing and then repeat with the other."
        },
        {
            step:'https://www.foldnfly.com/data/19/10.jpg',
            stepDesc:"10. Finally, accordion fold the nose to make it look like a beak, and cut four slits on the back of each wing to make feathers."
        },
      
    
        {
            step:'https://www.foldnfly.com/data/19/final.webp',
            stepDesc:"Widen the body for the full eagle effect and carefully bend the wing feathers up or down to get it to fly level. This is not the best performing paper airplane, but it looks cool."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/19/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/19/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/19/print_sample_2.png"
        },
     ]
    },
    {
     name: 'White Dove',
     imageFilename:'whitedovefull.webp',
     airoplane:'whitedove.png',
     shortInfo:'An origami paper airplane inspired by the peaceful dove.',
     longInfo:'If you really try, you can get this to slightly glide like a dove, but this creation is mostly decorative.',
     difficulty: 'Medium',
     distance: 'decorative',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/20/1.webp',
            stepDesc:'1. Fold one corner diagonally.'
        },
        {
            step:'https://www.foldnfly.com/data/20/2.webp',
            stepDesc:"2. Cut off the extra piece at the bottom."
        },
        {
            step:'https://www.foldnfly.com/data/20/3.webp',
            stepDesc:"3. Fold the peak of the triangle over leaving 1.5 inches for the wings."
        },
        {
            step:'https://www.foldnfly.com/data/20/4.webp',
            stepDesc:'4. Take one layer and fold it in the opposite direction as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/20/5.webp',
            stepDesc:'5. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/20/6.webp',
            stepDesc:'6. Fold one wing up at a slight angle.'
        },
        {
            step:'https://www.foldnfly.com/data/20/7.jpg',
            stepDesc:"7. Repeat step six with the other wing."
        },
        {
            step:'https://www.foldnfly.com/data/20/8.jpg',
            stepDesc:"8. Finally, fold down both wings and invert fold the head to create the beak."
        },
        {
            step:'https://www.foldnfly.com/data/20/final.webp',
            stepDesc:""
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/20/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/20/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/20/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Fast Hawk',
     imageFilename:'fasthawkfull.webp',
     airoplane:'fasthalk.png',
     shortInfo:'A fast paper airplane that can soar for miles with very little effort.',
     longInfo:'Like a hawk, this paper plane can glide over long distances. A little tricky to fold, but a reliable performer.',
     difficulty: 'Expert',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/21/1.webp',
            stepDesc:'1. Holding the paper width-wise, fold the top down about two inches.'
        },
        {
            step:'https://www.foldnfly.com/data/21/2.webp',
            stepDesc:"2. Fold the sheet in half vertically."
        },
        {
            step:'https://www.foldnfly.com/data/21/3.webp',
            stepDesc:"3. Fold the top right corner down to the left edge."
        },
        {
            step:'https://www.foldnfly.com/data/21/4.webp',
            stepDesc:'4. Repeat step three with the other side folding the opposite way.'
        },
        {
            step:'https://www.foldnfly.com/data/21/5.webp',
            stepDesc:'5. Open sheet back up as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/21/6.webp',
            stepDesc:'6. Accordion fold the top side rectangles in to get this shape.'
        },
        {
            step:'https://www.foldnfly.com/data/21/7.jpg',
            stepDesc:"7. Fold the bottom flaps up and tuck them under the triangle shape."
        },
        {
            step:'https://www.foldnfly.com/data/21/8.jpg',
            stepDesc:"8. Fold the peak back to the bottom edge of the paper."
        },
        {
            step:'https://www.foldnfly.com/data/21/9.jpg',
            stepDesc:"9. Flip the paper over and crease in the sides of the upside-down triangle."
        },
        {
            step:'https://www.foldnfly.com/data/21/10.jpg',
            stepDesc:"10. Invert fold the side in to get this shape."
        },
        {
            step:'https://www.foldnfly.com/data/21/11.jpg',
            stepDesc:"11. Now, fold the plane in half away from you."
        },
        {
            step:'https://www.foldnfly.com/data/21/12.jpg',
            stepDesc:"12. Fold down one wing as shown and repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/21/13.jpg',
            stepDesc:"13. Fold the ends of the wings tips up and you are done."
        },
        {
            step:'https://www.foldnfly.com/data/21/final.webp',
            stepDesc:"Give the wings an upward Y shape to improve performance. This dihedral angle will be more stable. To improve the flight characteristics, cut some aileron flaps on the back of the wings. These can be bent up or down to get this paper airplane to fly straight and level."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/21/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/21/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/21/print_sample_2.png"
        },
     ]
    },
    {
     name: 'King Bee',
     imageFilename:'kingbeefull.webp',
     airoplane:'kingbee.png',
     shortInfo:'This acrobatic paper airplane looks like a bee and darts around like one too.',
     longInfo:'If you throw this paper plane at the right angle, it will wiggle back and forth like a bee hunting for flowers.',
     difficulty: 'Medium',
     distance: 'acrobatic',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/22/1.webp',
            stepDesc:'1. Fold the corners down to each side and unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/22/2.webp',
            stepDesc:"2. Fold the top down so the three creases line up."
        },
        {
            step:'https://www.foldnfly.com/data/22/3.webp',
            stepDesc:"3. Open up the sheet and accordion fold the sides in."
        },
        {
            step:'https://www.foldnfly.com/data/22/4.webp',
            stepDesc:'4. Fold both edges of the triangle to the center (top layer only).'
        },
        {
            step:'https://www.foldnfly.com/data/22/5.webp',
            stepDesc:'5. Fold the top back to meet the bottom edge of the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/22/6.webp',
            stepDesc:'6. Fold up both middle flaps up.'
        },
        {
            step:'https://www.foldnfly.com/data/22/7.jpg',
            stepDesc:"7. Fold plane in half away from you."
        },
        {
            step:'https://www.foldnfly.com/data/22/8.jpg',
            stepDesc:"8. Fold down one wing as shown and then repeat with the other."
        },
        {
            step:'https://www.foldnfly.com/data/22/9.jpg',
            stepDesc:"9. If you want, fold up the tips of both wings and/or cut two aileron slits on the back of each wing."
        },
        {
            step:'https://www.foldnfly.com/data/22/final.webp',
            stepDesc:""
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/22/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/22/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/22/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Zip Dart',
     imageFilename:'zipdartfull.webp',
     airoplane:'zipdart.png',
     shortInfo:'If you are looking for speed and distance, this zippy dart is a great option.',
     longInfo:'The thin body and front stabilizing wings allows it to quickly zip through the air and quickly travel long distances.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/23/1.webp',
            stepDesc:'1. Fold the corner down to the other side of the paper.'
        },
        {
            step:'https://www.foldnfly.com/data/23/2.webp',
            stepDesc:"2. Unfold and repeat with the other corner. Then unfold again."
        },
        {
            step:'https://www.foldnfly.com/data/23/3.webp',
            stepDesc:"3. Accordion fold the sides in using the creases."
        },
        {
            step:'https://www.foldnfly.com/data/23/4.webp',
            stepDesc:'4. Fold the bottom corners of the triangle shape up (top layer).'
        },
        {
            step:'https://www.foldnfly.com/data/23/5.webp',
            stepDesc:'5. Now, take both upper outer edges and fold them to the center. Be sure they are tucked underneath the diamond shape.'
        },
        {
            step:'https://www.foldnfly.com/data/23/6.webp',
            stepDesc:'6. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/23/7.jpg',
            stepDesc:"7. Fold one wing down from the nose of the plane to the center of the tail."
        },
        {
            step:'https://www.foldnfly.com/data/23/8.jpg',
            stepDesc:"8. Repeat step seven with the other wing. Fold down the front flaps as well, however you want."
        },
       
        {
            step:'https://www.foldnfly.com/data/23/final.webp',
            stepDesc:"You can play around with the angle of the front stabilizing wings to adjust the flight characteristics of this airplane."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/23/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/23/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/23/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Jet Fighter',
     imageFilename:'jetfighterfull.webp',
     airoplane:'jetfighter.png',
     shortInfo:'This paper jet has a unique two level wing that gives it some style.',
     longInfo:'When adjusted correctly, this paper jet can glide for long distances.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/24/1.webp',
            stepDesc:'1. Fold the sheet in half vertically. Then, open and fold both corners down to the middle.'
        },
        {
            step:'https://www.foldnfly.com/data/24/2.webp',
            stepDesc:"2. Take one top edge and fold down to the bottom edge on the same side."
        },
        {
            step:'https://www.foldnfly.com/data/24/3.webp',
            stepDesc:"3. Open and repeat step two on the other side to get the creases shown in the picture."
        },
        {
            step:'https://www.foldnfly.com/data/24/4.webp',
            stepDesc:'4. Accordion fold the creases in to get this shape.'
        },
        {
            step:'https://www.foldnfly.com/data/24/5.webp',
            stepDesc:'5. Next, fold the bottom triangular piece back up.'
        },
        {
            step:'https://www.foldnfly.com/data/24/6.webp',
            stepDesc:'6. Fold back both outer points of the triangle shape. Be sure the folds are tucked in-between both layers.'
        },
        {
            step:'https://www.foldnfly.com/data/24/7.jpg',
            stepDesc:"7. Fold the plane in half away from you."
        },
        {
            step:'https://www.foldnfly.com/data/24/8.jpg',
            stepDesc:"8. Fold down one wing and then repeat with the other."
        },
        {
            step:'https://www.foldnfly.com/data/24/9.jpg',
            stepDesc:"9. Crease up the edges of each wing at an angle."
        },
       
        {
            step:'https://www.foldnfly.com/data/24/final.webp',
            stepDesc:"Use some tape to keep the fuselage together and two smaller pieces of tape to keep the two levels of wing together. Experiment with the side stabilizer fins and add wing flaps to control the flight."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/24/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/24/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/24/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Underside Plane',
     imageFilename:'undersideplanefull.webp',
     airoplane:'underside.png',
     shortInfo:'This paper glider has a slow circular flight pattern.',
     longInfo:'The extra underside flaps give the wings rigidity and help it glide better.',
     difficulty: 'Medium',
     distance: 'time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/27/1.webp',
            stepDesc:'1. Fold the paper in half vertically and horizontally, then open it back up.'
        },
        {
            step:'https://www.foldnfly.com/data/27/2.webp',
            stepDesc:"2. Holding the paper width-wise, fold the top edge down to meet the center crease."
        },
        {
            step:'https://www.foldnfly.com/data/27/3.webp',
            stepDesc:"3. Fold the top edge down at the center crease."
        },
        {
            step:'https://www.foldnfly.com/data/27/4.webp',
            stepDesc:'4. Now, fold the top right corner down along the center fold as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/27/5.webp',
            stepDesc:'5. Repeat with the left side and it should look like this.'
        },
        {
            step:'https://www.foldnfly.com/data/27/6.webp',
            stepDesc:'6. Again, fold the corner down to meet the horizontal fold.'
        },
        {
            step:'https://www.foldnfly.com/data/27/7.jpg',
            stepDesc:"7. Repeat step six on the right side."
        },
        {
            step:'https://www.foldnfly.com/data/27/8.jpg',
            stepDesc:"8. Next, fold the top peak down to meet the horizontal fold."
        },
        {
            step:'https://www.foldnfly.com/data/27/9.jpg',
            stepDesc:"9. Fold the plane in half away from you."
        },
        {
            step:'https://www.foldnfly.com/data/27/10.jpg',
            stepDesc:"10. Now, fold one wing out about one inch from the bottom of the plane."
        },
        {
            step:'https://www.foldnfly.com/data/27/11.jpg',
            stepDesc:"11. Finally. fold down the second wing so it looks like this."
        },
       
        {
            step:'https://www.foldnfly.com/data/27/final.webp',
            stepDesc:"Hold the wings in upward Y shape and use a piece of tape to hold the wings together at this angle. This dihedral angle will allow this glider to stay aloft longer."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/27/rect.webp"
        },
        {
            print:"https://www.foldnfly.com/data/27/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/27/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Silor Wing Plane',
     imageFilename:'sailorfull.webp',
     airoplane:'sailor.png',
     shortInfo:'This paper glider will slide through the air in a slow and steady straight line.',
     longInfo:'All it needs is a slight push and you’ll see it go. The lifted tail helps with stability.',
     difficulty: 'Expert',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/28/1.webp',
            stepDesc:'1. Fold the top right corner to the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/28/2.webp',
            stepDesc:"2. Open the sheet back up and repeat the same step with the left corner."
        },
        {
            step:'https://www.foldnfly.com/data/28/3.webp',
            stepDesc:"3. Open the sheet back up and accordion fold both sides in so it looks like this."
        },
        {
            step:'https://www.foldnfly.com/data/28/4.webp',
            stepDesc:'4. Next, fold the bottom right corner of the triangle shape up to the peak.'
        },
        {
            step:'https://www.foldnfly.com/data/28/5.webp',
            stepDesc:'5. Repeat with the left corner..'
        },
        {
            step:'https://www.foldnfly.com/data/28/6.webp',
            stepDesc:'6. Now, fold the bottom right edge of the diamond shape to the center line..'
        },
        {
            step:'https://www.foldnfly.com/data/28/7.jpg',
            stepDesc:"7. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/28/8.jpg',
            stepDesc:"8. Fold down the peak of the plane."
        },
        {
            step:'https://www.foldnfly.com/data/28/9.jpg',
            stepDesc:"9. Open up the slots in the top peak and slide the corner of the flaps into them."
        },
        {
            step:'https://www.foldnfly.com/data/28/10.jpg',
            stepDesc:"10. Flip the plane over."
        },
        {
            step:'https://www.foldnfly.com/data/28/11.jpg',
            stepDesc:"11. With a ruler, fold the right side over along the top and bottom corners."
        },
        {
            step:'https://www.foldnfly.com/data/28/12.jpg',
            stepDesc:"12. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/28/13.jpg',
            stepDesc:"13. Take the previous folds and fold them back to the outer edges as shown."
        },
        {
            step:'https://www.foldnfly.com/data/28/14.jpg',
            stepDesc:"14. Now fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/28/15.jpg',
            stepDesc:"15. Hold the plane in your hands and invert fold the tail end in."
        },
        {
            step:'https://www.foldnfly.com/data/28/16.jpg',
            stepDesc:"16. Fold one wing out like this."
        },
        {
            step:'https://www.foldnfly.com/data/28/17.jpg',
            stepDesc:"17. Finally, repeat with the other side and extend the wings."
        },
       
        {
            step:'https://www.foldnfly.com/data/28/final.webp',
            stepDesc:"This is a reliable design that consistently performs well with long straight flights. It is not necessary to staple or tape the body shut. In fact, it works best if the V shape of the body is a 90 degree angle."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/28/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/28/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/28/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Lock-Bottom Plane',
     imageFilename:'lockbottomfull.webp',
     airoplane:'lockbottom.png',
     shortInfo:'An easy paper airplane that flies farther that most other designs.',
     longInfo:'It shoots straight through the air with a quick push and keeps going and going.',
     difficulty: 'Easy',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/29/1.webp',
            stepDesc:'1. Fold the plane in half and open it back up.'
        },
        {
            step:'https://www.foldnfly.com/data/29/2.webp',
            stepDesc:"2. Fold both corners in along the center line."
        },
        {
            step:'https://www.foldnfly.com/data/29/3.webp',
            stepDesc:"3. Fold the peak down about 1 inch before the bottom edge."
        },
        {
            step:'https://www.foldnfly.com/data/29/4.webp',
            stepDesc:'4. Again, fold both corner in to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/29/5.webp',
            stepDesc:'5. Take the extra piece at the bottom and fold it up to lock down the two flaps.'
        },
        {
            step:'https://www.foldnfly.com/data/29/6.webp',
            stepDesc:'6. Now, fold the plane in half away from you.'
        },
        {
            step:'https://www.foldnfly.com/data/29/7.jpg',
            stepDesc:"7. Fold one wing down about one inch from the belly of the plane."
        },
        {
            step:'https://www.foldnfly.com/data/29/8.jpg',
            stepDesc:"8. Repeat with the other wing."
        },
        {
            step:'https://www.foldnfly.com/data/29/9.jpg',
            stepDesc:"9. Next, fold up the ends of each wing about a half inch."
        },
        {
            step:'https://www.foldnfly.com/data/29/10.jpg',
            stepDesc:"10. Finally, take a pair of scissors and cut two small slits at the tail end of each wing."
        },
        {
            step:'https://www.foldnfly.com/data/29/final.webp',
            stepDesc:"Once you have adjusted the ailerons to get it to fly straight, this is a very reliable airplane that can go very far."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/29/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/29/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/29/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Bird',
     imageFilename:'thebirdfull.webp',
     airoplane:'thebird.png',
     shortInfo:'The birdlike wings give this fast flying paper airplane a lot of stability during flight.',
     longInfo:"This is a very reliable distance flyer. We've given precise measurements below, but feel free to experiment with the wings.",
     difficulty: 'Hard',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/32/1.webp',
            stepDesc:'1. Fold the top right corner diagonally.'
        },
        {
            step:'https://www.foldnfly.com/data/32/2.webp',
            stepDesc:"2. Open the sheet back up and repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/32/3.webp',
            stepDesc:"3. Now fold the top down and fold along the center part of the X shape."
        },
        {
            step:'https://www.foldnfly.com/data/32/4.webp',
            stepDesc:'4. Unfold and flatten the sheet of paper.'
        },
        {
            step:'https://www.foldnfly.com/data/32/5.webp',
            stepDesc:'5. Next, fold down the top edge so it meets the horizontal crease.'
        },
        {
            step:'https://www.foldnfly.com/data/32/6.webp',
            stepDesc:'6. Now fold the top section down again along the horizontal crease.'
        },
        {
            step:'https://www.foldnfly.com/data/32/7.jpg',
            stepDesc:"7. Take the top outer edge so it meets the diagonal crease and then repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/32/8.jpg',
            stepDesc:"8. Fold the top edges along the diagonal lines to create the peak of the plane."
        },
        {
            step:'https://www.foldnfly.com/data/32/9.jpg',
            stepDesc:"9. Next, fold the peak down as shown."
        },
        {
            step:'https://www.foldnfly.com/data/32/10.jpg',
            stepDesc:"10. At the top edge of the plane, measure 1.6cm from the center to the left and right. Then, measure 2.5cm from the bottom center and connect the points."
        },
        {
            step:'https://www.foldnfly.com/data/32/11.jpg',
            stepDesc:"11. Fold along those measured lines. Use our printable instructions if you don't want to measure."
        },
        {
            step:'https://www.foldnfly.com/data/32/12.jpg',
            stepDesc:"12. Measure 3.1cm from the top outer corner and then 3.1cm again from the first point. Measure 2.5cm from the bottom of the vertical line and again from that point."
        },
        {
            step:'https://www.foldnfly.com/data/32/13.jpg',
            stepDesc:"13. Fold along the lines."
        },
        {
            step:'https://www.foldnfly.com/data/32/14.jpg',
            stepDesc:"14. Finally, tape the nose of the plane together."
        },
        {
            step:'https://www.foldnfly.com/data/32/final.webp',
            stepDesc:"Looking head on, adjust the wings until they look symmetrical, then throw it hard at a slight upwards angle to see how fast and far it can go."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/32/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/32/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/32/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Fast Swallow',
     imageFilename:'fastswallowfull.webp',
     airoplane:'fastswallow.png',
     shortInfo:'The distinctive tail shape gives this paper airplane a unique look.',
     longInfo:'The tail and wide wings allows this paper airplane to soar in the wind.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/33/1.webp',
            stepDesc:'1. Fold the sheet of paper in half vertically and horizontally.'
        },
        {
            step:'https://www.foldnfly.com/data/33/2.webp',
            stepDesc:"2. Next, fold the top edge down to meet the center crease."
        },
        {
            step:'https://www.foldnfly.com/data/33/3.webp',
            stepDesc:"3. Again, take the top edge and fold to the center."
        },
        {
            step:'https://www.foldnfly.com/data/33/4.webp',
            stepDesc:'4. Repeat the previous step once again.'
        },
        {
            step:'https://www.foldnfly.com/data/33/5.webp',
            stepDesc:'5. Measure one inch to the left and right of the center line and connect the marks.'
        },
        {
            step:'https://www.foldnfly.com/data/33/6.webp',
            stepDesc:'6. Now, measure 3 inches from the bottom on both sides and connect.'
        },
        {
            step:'https://www.foldnfly.com/data/33/7.jpg',
            stepDesc:"7. Measure 1.5 inches in from the horizontal line and the bottom edge and connect the marks to make the shorter vertical lines."
        },
        {
            step:'https://www.foldnfly.com/data/33/8.jpg',
            stepDesc:"8. Next, connect the two points as shown in the image."
        },
        {
            step:'https://www.foldnfly.com/data/33/9.jpg',
            stepDesc:"9. Cut out the shapes to leave only these two peaks for the tail."
        },
        {
            step:'https://www.foldnfly.com/data/33/10.jpg',
            stepDesc:"10. Fold the plane in half towards you and cut along the dotted line, 1/2 inch down from the right corner."
        },
        {
            step:'https://www.foldnfly.com/data/33/11.jpg',
            stepDesc:"11. Now, fold the wings out along the lines as shown and flip the thin tail stabilizer up."
        },
        {
            step:'https://www.foldnfly.com/data/33/12.jpg',
            stepDesc:"12. Finally, glue or tape the nose of the plane and both ends of the wings."
        },
       
        {
            step:'https://www.foldnfly.com/data/33/final.webp',
            stepDesc:"To steer this paper airplane, slightly bend the tail feathers up or down."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/33/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/33/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/33/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Soaring Eagle',
     imageFilename:'soaringeaglefull.webp',
     airoplane:'soaringeagle.png',
     shortInfo:'This fast paper airplane soars well indoors and out.',
     longInfo:'A glider that circles in the air like an eagle search for its next meal.',
     difficulty: 'Hard',
     distance: 'time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/34/1.webp',
            stepDesc:'1. Measure around 2.5 inches down from the top corners and connect the marks.'
        },
        {
            step:'https://www.foldnfly.com/data/34/2.webp',
            stepDesc:"2. Fold the top edge down to the line and then fold it down again at the line."
        },
        {
            step:'https://www.foldnfly.com/data/34/3.webp',
            stepDesc:"3. Next, fold the plane in half away from you."
        },
        {
            step:'https://www.foldnfly.com/data/34/4.webp',
            stepDesc:'4. Fold the top right corner down along the opposite edge.'
        },
        {
            step:'https://www.foldnfly.com/data/34/5.webp',
            stepDesc:'5. Flip the plane around and repeat with the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/34/6.webp',
            stepDesc:'6. Unfold everything back to step two. Then fold the top corners so they meet the diagonal creases.'
        },
        {
            step:'https://www.foldnfly.com/data/34/7.jpg',
            stepDesc:"7. Fold the top corners in again, along the creases, to the center."
        },
        {
            step:'https://www.foldnfly.com/data/34/8.jpg',
            stepDesc:"8. Fold the top peak down to the bottom edge."
        },
        {
            step:'https://www.foldnfly.com/data/34/9.jpg',
            stepDesc:"9. Fold the peak back up as shown."
        },
        {
            step:'https://www.foldnfly.com/data/34/10.jpg',
            stepDesc:"10. Fold the top outer edges along each side of the triangle shape."
        },
        {
            step:'https://www.foldnfly.com/data/34/11.jpg',
            stepDesc:"11. Click the image above to enlarge it and use a ruler to copy the measurements for the folding lines."
        },
        {
            step:'https://www.foldnfly.com/data/34/12.jpg',
            stepDesc:"12. Now, fold the plane in half and fold the wings out along the lines."
        },
        
        {
            step:'https://www.foldnfly.com/data/34/13.jpg',
            stepDesc:"13. Tape, glue or staple the nose of the plane together."
        },
       
        {
            step:'https://www.foldnfly.com/data/34/final.webp',
            stepDesc:"The measurements above do not need to be exact, if you don't have a ruler handy. Add a staple at the center of mass (around 2 inches from the tip) to keep the fuselage together. Make sure it's symmetrical and let it fly!"
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/34/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/34/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/34/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Navy Plane',
     imageFilename:'navyplanefull.webp',
     airoplane:'navyplane.png',
     shortInfo:'Designed to look like a fighter jet, this paper airplane is made for speed.',
     longInfo:'Throw this paper jet as fast as you can and go for distance.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/35/1.webp',
            stepDesc:'1. Holding the paper horizontally, fold in half and then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/35/2.webp',
            stepDesc:"2. Fold down both top corners to the center."
        },
        {
            step:'https://www.foldnfly.com/data/35/3.webp',
            stepDesc:"3. Fold the tip of the plane down to meet the previous fold."
        },
        {
            step:'https://www.foldnfly.com/data/35/4.webp',
            stepDesc:'4. Fold down the top right corner, aligning it with the center.'
        },
        {
            step:'https://www.foldnfly.com/data/35/5.webp',
            stepDesc:'5. Now repeat with the left corner.'
        },
        {
            step:'https://www.foldnfly.com/data/35/6.webp',
            stepDesc:'6. Turn the plane around and fold the right bottom corner to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/35/7.jpg',
            stepDesc:"7. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/35/8.jpg',
            stepDesc:"8. Next, fold the right edge towards the center, as shown."
        },
        {
            step:'https://www.foldnfly.com/data/35/9.jpg',
            stepDesc:"9. Repeat with the left edge."
        },
        {
            step:'https://www.foldnfly.com/data/35/10.jpg',
            stepDesc:"10. Now, fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/35/11.jpg',
            stepDesc:"11. Fold one wing down as shown."
        },
        {
            step:'https://www.foldnfly.com/data/35/12.jpg',
            stepDesc:"12. Repeat with the other wing."
        },
       
        {
            step:'https://www.foldnfly.com/data/35/13.jpg',
            stepDesc:"13. Finally, fold up the two tail flaps."
        },
       
        {
            step:'https://www.foldnfly.com/data/35/final.webp',
            stepDesc:"If your jet dives towards the ground, create some elevons on the wings and bend them up a little bit to get your paper jet to stay aloft longer."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/35/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/35/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/35/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Canard Plane',
     imageFilename:'canardplanefull.webp',
     airoplane:'canardplane.png',
     shortInfo:'A steady distance flyer that stays on target.',
     longInfo:'The small front wings on this paper airplane are called canard wings, and they help stabilize the airplane during flight.',
     difficulty: 'Hard',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/36/1.webp',
            stepDesc:'1. Fold your paper in half vertically and then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/36/2.webp',
            stepDesc:"2. Fold both upper corners to the center."
        },
        {
            step:'https://www.foldnfly.com/data/36/3.webp',
            stepDesc:"3. Now, fold the outer edges to the center."
        },
        {
            step:'https://www.foldnfly.com/data/36/4.webp',
            stepDesc:'4. Next, open the sheet back up and fold down the right side. The second crease should meet the center line. Then fold the corner out.'
        },
        {
            step:'https://www.foldnfly.com/data/36/5.webp',
            stepDesc:'5. Repeat with the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/36/6.webp',
            stepDesc:'6. Fold down the top point to meet where the other folds come together.'
        },
        {
            step:'https://www.foldnfly.com/data/36/7.jpg',
            stepDesc:"7. Now, fold up the point back up to meet the top edge."
        },
        {
            step:'https://www.foldnfly.com/data/36/8.jpg',
            stepDesc:"8. Next, fold in the right outer flap."
        },
        {
            step:'https://www.foldnfly.com/data/36/9.jpg',
            stepDesc:"9. Repeat with the left flap"
        },
        {
            step:'https://www.foldnfly.com/data/36/10.jpg',
            stepDesc:"10. Fold out the right flap so that the crease lines up with the outer corner."
        },
        {
            step:'https://www.foldnfly.com/data/36/11.jpg',
            stepDesc:"11. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/36/12.jpg',
            stepDesc:"12. Now, fold the plane in half away from you."
        },
       
        {
            step:'https://www.foldnfly.com/data/36/13.jpg',
            stepDesc:"13. Fold down one wing as shown."
        },
        {
            step:'https://www.foldnfly.com/data/36/14.jpg',
            stepDesc:"14. Finally, fold out the other wing."
        },
       
        {
            step:'https://www.foldnfly.com/data/36/final.webp',
            stepDesc:"If you prefer the look of having the folds hidden inside the airplane, you can reverse the fold in step 12. This will make the airplane thicker, so you'll need to use some tape to keep it all together."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/36/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/36/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/36/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Tail Spin',
     imageFilename:'tailspinfull.webp',
     airoplane:'tailspin.png',
     shortInfo:'An acrobatic paper airplane that spins through the air.',
     longInfo:'Using tail flaps that are bent in opposite directions gives this paper airplane some dramatic spinning acrobatics.',
     difficulty: 'Easy',
     distance: 'acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/37/1.webp',
            stepDesc:'1. Fold the sheet in half vertically and unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/37/2.webp',
            stepDesc:"2. Next, fold both upper corner to the center."
        },
        {
            step:'https://www.foldnfly.com/data/37/3.webp',
            stepDesc:"3. Fold the top right edge to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/37/4.webp',
            stepDesc:'4. Repeat with the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/37/5.webp',
            stepDesc:'5. Now, fold the top point down about 2 inches, as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/37/6.webp',
            stepDesc:'6. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/37/7.jpg',
            stepDesc:"7. Next, fold down one wing to meet the center line."
        },
        {
            step:'https://www.foldnfly.com/data/37/8.jpg',
            stepDesc:"8. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/37/9.jpg',
            stepDesc:"9. Finally, fold the back tips of the wings in opposite directions, as shown."
        },
       
        {
            step:'https://www.foldnfly.com/data/37/final.webp',
            stepDesc:"Use a small piece of tape to keep the airplane fuselage together. Reverse the direction of the flaps to get the paper airplane to spin in the other direction. Or, return the flaps to the neutral position if you want it to fly without spinning."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/37/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/37/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/37/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Lift Off',
     imageFilename:'liftofffull.webp',
     airoplane:'liftoff.png',
     shortInfo:'Use a rubber band to add a little more power to the launch of this paper airplane.',
     longInfo:'Fling this paper airplane at high speeds, either straight up like a rocket or long distance like a jet.',
     difficulty: 'Easy',
     distance: 'distance',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/38/1.webp',
            stepDesc:'1. Fold the sheet in half and then fold both upper corner to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/38/2.webp',
            stepDesc:"2. Next, fold the top point back about 3cm."
        },
        {
            step:'https://www.foldnfly.com/data/38/3.webp',
            stepDesc:"3. Fold both upper edges to the center line."
        },
        {
            step:'https://www.foldnfly.com/data/38/4.webp',
            stepDesc:'4. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/38/5.webp',
            stepDesc:'5. Grab a pair of scissors and cut out a slit like the one shown here.'
        },
        {
            step:'https://www.foldnfly.com/data/38/6.webp',
            stepDesc:'6. Now, fold out the first wing.'
        },
        {
            step:'https://www.foldnfly.com/data/38/7.jpg',
            stepDesc:"7. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/38/8.jpg',
            stepDesc:"8. Finally, grab a rubber band and use it to fling the airplane across the room."
        },
       
        {
            step:'https://www.foldnfly.com/data/38/final.webp',
            stepDesc:"If needed, add a piece of tape to reinforce the notch on the nose. Tie the other end of the rubber band to a small stick so you have something easy to hold."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/38/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/38/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/38/print_sample_2.png"
        },
     ]
    },
    {
     name: 'V-Wing',
     imageFilename:'vwingfull.webp',
     airoplane:'vwing.png',
     shortInfo:'A smooth sailing paper airplane with a simple silhouette.',
     longInfo:'Like a stealthy spy plane, this paper glider flies quietly through the air.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/39/1.webp',
            stepDesc:'1. First, cut 2.5 inches off the bottom to make a perfectly square piece of paper.'
        },
        {
            step:'https://www.foldnfly.com/data/39/2.webp',
            stepDesc:"2. Fold the sheet in half and then open back up."
        },
        {
            step:'https://www.foldnfly.com/data/39/3.webp',
            stepDesc:"3. Fold both upper corners to the center line as shown."
        },
        {
            step:'https://www.foldnfly.com/data/39/4.webp',
            stepDesc:'4. Fold the top point down to meet the corners from the previous step.'
        },
        {
            step:'https://www.foldnfly.com/data/39/5.webp',
            stepDesc:'5. Fold the right upper corner to the center again.'
        },
        {
            step:'https://www.foldnfly.com/data/39/6.webp',
            stepDesc:'6. Repeat with the other side, and then fold the plane in half away from you.'
        },
        {
            step:'https://www.foldnfly.com/data/39/7.jpg',
            stepDesc:"7. Finally, fold out the wings. They should come to a point in the front and taper up towards the back."
        },
       
        {
            step:'https://www.foldnfly.com/data/39/final.webp',
            stepDesc:"This steady glider is very reliable and requires few adjustments, but you can fold the tail flaps up or down as needed to get this paper airplane to fly level and straight."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/39/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/39/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/39/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Vulture',
     imageFilename:'vulturefull.webp',
     airoplane:'vulture.png',
     shortInfo:'A small and fast flying paper plane.',
     longInfo:'This compact paper airplane makes up for its size with speed. Throw it hard and watch it sail.',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/40/1.webp',
            stepDesc:'1. Fold the sheet in half vertically.'
        },
        {
            step:'https://www.foldnfly.com/data/40/2.webp',
            stepDesc:"2. Open the sheet back up and fold in half horizontally."
        },
        {
            step:'https://www.foldnfly.com/data/40/3.webp',
            stepDesc:"3. With the folded paper held with the opening on the bottom, fold both left and right edges to the center"
        },
        {
            step:'https://www.foldnfly.com/data/40/4.webp',
            stepDesc:'4. Open the last two folds and then fold the top corner down to the first crease.'
        },
        {
            step:'https://www.foldnfly.com/data/40/5.webp',
            stepDesc:'5. Repeat with the other side.'
        },
        {
            step:'https://www.foldnfly.com/data/40/6.webp',
            stepDesc:'6. Now, fold the top right edge down to the center line.'
        },
        {
            step:'https://www.foldnfly.com/data/40/7.jpg',
            stepDesc:"7. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/40/8.jpg',
            stepDesc:"8. Open those last steps back up and accordion fold the right side in."
        },
        {
            step:'https://www.foldnfly.com/data/40/9.jpg',
            stepDesc:"9. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/40/10.jpg',
            stepDesc:"10. Take the top layer of both outer edges and line them up with the diagonal creases."
        },
        {
            step:'https://www.foldnfly.com/data/40/11.jpg',
            stepDesc:"11. Fold them in again along the diagonal creases."
        },
        {
            step:'https://www.foldnfly.com/data/40/12.jpg',
            stepDesc:"12. Flip the plane around and repeat steps 10 and 11 on this side."
        },
        {
            step:'https://www.foldnfly.com/data/40/13.jpg',
            stepDesc:"13. Fold the tip about an inch down as shown."
        },
        {
            step:'https://www.foldnfly.com/data/40/14.jpg',
            stepDesc:"14. Now, fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/40/15.jpg',
            stepDesc:"15. Fold down one wing. The body will be about 1/2 inch tall."
        },
        {
            step:'https://www.foldnfly.com/data/40/16.jpg',
            stepDesc:"16. Repeat with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/40/17.jpg',
            stepDesc:"17. Finally, fold the tail fins up as shown."
        },
       
        {
            step:'https://www.foldnfly.com/data/40/final.webp',
            stepDesc:"In our testing, this plane liked to fly in a big fast boomerang loop back to us. Try adjusting the tail fins, and you can get this design to do a few other tricks."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/40/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/40/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/40/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Sonic Jet',
     imageFilename:'sonicjetfull.webp',
     airoplane:'sonicjet.png',
     shortInfo:'A paper jet that can reach supersonic speeds as it soars through the air.',
     longInfo:'This design looks like a fighter jet, complete with a cockpit for the pilot to fly the paper airplane..',
     difficulty: 'Hard',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/41/1.webp',
            stepDesc:'1. Fold the plane in half vertically.'
        },
        {
            step:'https://www.foldnfly.com/data/41/2.webp',
            stepDesc:"2. Open it back up and then fold in half horizontally."
        },
        {
            step:'https://www.foldnfly.com/data/41/3.webp',
            stepDesc:"3. Open the sheet all the way and fold the top two corners to the center."
        },
        {
            step:'https://www.foldnfly.com/data/41/4.webp',
            stepDesc:'4. Again, both top edges to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/41/5.webp',
            stepDesc:'5. Flip the plane around and fold the top point to the bottom edge.'
        },
        {
            step:'https://www.foldnfly.com/data/41/6.webp',
            stepDesc:'6. Flip it around again and fold both corners to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/41/7.jpg',
            stepDesc:"7. Again, flip it around and fold the point back up."
        },
        {
            step:'https://www.foldnfly.com/data/41/8.jpg',
            stepDesc:"8. Flip it around one last time and fold the center flaps out as shown."
        },
        {
            step:'https://www.foldnfly.com/data/41/9.jpg',
            stepDesc:"9. Next, fold the plane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/41/10.jpg',
            stepDesc:"10. Finally, fold both wings out."
        },       
        {
            step:'https://www.foldnfly.com/data/41/final.webp',
            stepDesc:"Use a bit of tape to keep the paper airplane body tight together. A slight upward bend of the trailing wings can help it stay up longer. The triangle pieces pointing up in the middle looks like the cockpit where the pilot would sit, so draw a little pilot sitting in there, if you want."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/41/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/41/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/41/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Spinner Plane',
     imageFilename:'spinnerplanefull.webp',
     airoplane:'spinnerplane.png',
     shortInfo:'A fun and easy paper plane that might get you a little dizzy.',
     longInfo:'Designed to spin through the air with amazing aerobatics.',
     difficulty: 'Medium',
     distance: 'acrobatic,decorative',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/42/1.webp',
            stepDesc:'1. Fold the top right corner to the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/42/2.webp',
            stepDesc:"2. Open the sheet back up and repeat the same step with the left corner."
        },
        {
            step:'https://www.foldnfly.com/data/42/3.webp',
            stepDesc:"3. Open the sheet back up and accordion fold both sides in so it looks like this."
        },
        {
            step:'https://www.foldnfly.com/data/42/4.webp',
            stepDesc:'4. Next, fold the bottom layer to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/42/5.webp',
            stepDesc:'5. Repeat with the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/42/6.webp',
            stepDesc:'6. Now, fold the right side of the triangle shape to the top peak.'
        },
        {
            step:'https://www.foldnfly.com/data/42/7.jpg',
            stepDesc:"7. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/42/8.jpg',
            stepDesc:"8. Fold up the bottom edges of the diamond shape."
        },
        {
            step:'https://www.foldnfly.com/data/42/9.jpg',
            stepDesc:"9. Fold the top point down and tuck in the flaps as shown."
        },
        {
            step:'https://www.foldnfly.com/data/42/10.jpg',
            stepDesc:"10. Fold the plane in half."
        },       
        {
            step:'https://www.foldnfly.com/data/42/11.jpg',
            stepDesc:"11. Fold out one wing and line it up with the fold in the center."
        },       
        {
            step:'https://www.foldnfly.com/data/42/12.jpg',
            stepDesc:"12. Repeat with the other side."
        },       
        {
            step:'https://www.foldnfly.com/data/42/13.jpg',
            stepDesc:"13. Finally, fold the wing tips in opposite directions."
        },       
        {
            step:'https://www.foldnfly.com/data/42/final.webp',
            stepDesc:"You can adjust how quickly this paper airplane spins through the air by bending the tail flaps more or less. Or, if you don't want it to spin at all, point the flaps in the same direction."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/42/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/42/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/42/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Stealth Gilder',
     imageFilename:'steathgliderfull.webp',
     airoplane:'steathglider.png',
     shortInfo:'Lightly throw this paper airplane into the air and watch it glide.',
     longInfo:'Try throwing it from a balcony or other high location to watch it soar for a long time.',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/43/1.webp',
            stepDesc:'1. Fold the top right corner to the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/43/2.webp',
            stepDesc:"2. Open the sheet back up and repeat the same step with the left corner."
        },
        {
            step:'https://www.foldnfly.com/data/43/3.webp',
            stepDesc:"3. Open the sheet back up and accordion fold both sides in so it looks like the photo."
        },
        {
            step:'https://www.foldnfly.com/data/43/4.webp',
            stepDesc:'4. Next, fold the right side of the triangle shape to the top point.'
        },
        {
            step:'https://www.foldnfly.com/data/43/5.webp',
            stepDesc:'5. Repeat with the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/43/6.webp',
            stepDesc:'6. Now, fold in the bottom right edge of the diamond shape.'
        },
        {
            step:'https://www.foldnfly.com/data/43/7.jpg',
            stepDesc:"7. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/43/8.jpg',
            stepDesc:"8. Fold down the top point and tuck in the flaps as shown."
        },
        {
            step:'https://www.foldnfly.com/data/43/9.jpg',
            stepDesc:"9. Gently fold the plane in half away from you, but don't crease it too hard. We want it to be partly open."
        },
        {
            step:'https://www.foldnfly.com/data/43/10.jpg',
            stepDesc:"10. Finally, fold out the ends of each wing as shown."
        },       
       
        {
            step:'https://www.foldnfly.com/data/43/final.webp',
            stepDesc:"The ideal angle between the two wings is around 120 degrees, a wide V shape. This dihedral angle will be more stable."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/43/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/43/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/43/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Light Spinner',
     imageFilename:'lightspinnerfull.webp',
     airoplane:'lightspinner.png',
     shortInfo:'An acrobatic paper airplane design that will corkscrew through the air.',
     longInfo:'This paper plane will fly a large spiral through the air.',
     difficulty: 'Medium',
     distance: 'distance,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/44/1.webp',
            stepDesc:'1. Fold the top right corner to the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/44/2.webp',
            stepDesc:"2. Open the sheet back up and repeat the same step with the left corner."
        },
        {
            step:'https://www.foldnfly.com/data/44/3.webp',
            stepDesc:"3. Open the sheet back up and accordion fold both sides in so it looks like this."
        },
        {
            step:'https://www.foldnfly.com/data/44/4.webp',
            stepDesc:'4. Next, fold the top point down to the middle edge.'
        },
        {
            step:'https://www.foldnfly.com/data/44/5.webp',
            stepDesc:'5. Fold both triangle flaps into the center.'
        },
        {
            step:'https://www.foldnfly.com/data/44/6.webp',
            stepDesc:'6. Take each triangle flap, fold them up and tuck them into the previously folded top triangle.'
        },
        {
            step:'https://www.foldnfly.com/data/44/7.jpg',
            stepDesc:"7. Fold the plane in half with the triangle on the outside."
        },
        {
            step:'https://www.foldnfly.com/data/44/8.jpg',
            stepDesc:"8. Fold out both wings about 1 inch from the center."
        },
        {
            step:'https://www.foldnfly.com/data/44/9.jpg',
            stepDesc:"9. Finally, fold out the wing flaps in opposite directions, one up and one down."
        },  
       
        {
            step:'https://www.foldnfly.com/data/44/final.webp',
            stepDesc:"The wing flaps folded in opposite directions will cause this paper plane to spiral through the air like a corkscrew. Adjust the wing flap angles to adjust the size of the spiral."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/44/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/44/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/44/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Fun Flyer',
     imageFilename:'funflyerfull.webp',
     airoplane:'funflyer.png',
     shortInfo:'This paper airplane is fun to fold and fun to fly.',
     longInfo:'Try throwing it straight up and see if you can catch it on the way down.',
     difficulty: 'Hard',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/45/1.webp',
            stepDesc:'1. Fold the top right corner to the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/45/2.webp',
            stepDesc:"2. Repeat the last step with the other side."
        },
        {
            step:'https://www.foldnfly.com/data/45/3.webp',
            stepDesc:"3. Open the sheet back up and accordion fold the sides into the center."
        },
        {
            step:'https://www.foldnfly.com/data/45/4.webp',
            stepDesc:'4. Fold the bottom ends of the triangle shape to the top point.'
        },
        {
            step:'https://www.foldnfly.com/data/45/5.webp',
            stepDesc:'5. Fold down both flaps of the diamond shape, then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/45/6.webp',
            stepDesc:'6. Fold the top edges of the diamond shape to the middle and then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/45/7.jpg',
            stepDesc:"7. Repeat with the bottom edges of the diamond shape and unfold again."
        },
        {
            step:'https://www.foldnfly.com/data/45/8.jpg',
            stepDesc:"8. Now, accordion fold both the top and bottom triangles in at the same time and pinch the middle upwards."
        },
        {
            step:'https://www.foldnfly.com/data/45/9.jpg',
            stepDesc:"9. Fold the little center flaps up towards the top."
        }, 
        {
            step:'https://www.foldnfly.com/data/45/10.jpg',
            stepDesc:"10. Flip the airplane around and fold the top down so the center flaps now stick out in front."
        }, 
        {
            step:'https://www.foldnfly.com/data/45/11.jpg',
            stepDesc:"11. Fold the plane in half away from you."
        }, 
        {
            step:'https://www.foldnfly.com/data/45/12.jpg',
            stepDesc:"12. Fold down the first wing as shown."
        }, 
        {
            step:'https://www.foldnfly.com/data/45/13.jpg',
            stepDesc:"13. Finally, fold out the second wing."
        }, 
        {
            step:'https://www.foldnfly.com/data/45/final.webp',
            stepDesc:"Allow the body to remain open for best performance. Pinch it just enough to give your fingers something to grip. If it tends to dive, bend up some small flaps in the back."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/45/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/45/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/45/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Loop Plane',
     imageFilename:'loopplanefull.webp',
     airoplane:'loopplane.png',
     shortInfo:'This paper airplane can fly a big loop-the-loop in the air and keep flying.',
     longInfo:'This is a decent glider that we have turned into an acrobatic vertical loop flying paper plane.',
     difficulty: 'Easy',
     distance: 'acrobatic,decorative',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/46/1.webp',
            stepDesc:'1. Place the sheet horizontally and fold it in half from left to right. Open the sheet back up.'
        },
        {
            step:'https://www.foldnfly.com/data/46/2.webp',
            stepDesc:"2. Fold down the top left corner to the center, so that the crease lines up with the corner."
        },
        {
            step:'https://www.foldnfly.com/data/46/3.webp',
            stepDesc:"3. Repeat the previous step with the right side."
        },
        {
            step:'https://www.foldnfly.com/data/46/4.webp',
            stepDesc:'4. Next, fold down the top edge about half an inch.'
        },
        {
            step:'https://www.foldnfly.com/data/46/5.webp',
            stepDesc:'5. Fold down the top edge three more times.'
        },
        {
            step:'https://www.foldnfly.com/data/46/6.webp',
            stepDesc:'6. Now, fold the plane in half towards you.'
        },
        {
            step:'https://www.foldnfly.com/data/46/7.jpg',
            stepDesc:"7. Fold out one wing so the crease is parallel to the belly of the plane, which should be about 1 inch tall."
        },
        {
            step:'https://www.foldnfly.com/data/46/8.jpg',
            stepDesc:"8. Repeat with the other wing."
        },
        {
            step:'https://www.foldnfly.com/data/46/9.jpg',
            stepDesc:"9. Next, fold out both wing flaps."
        }, 
        {
            step:'https://www.foldnfly.com/data/46/10.jpg',
            stepDesc:"10. Finally, cut two slits on the end of each wing, a little over 2 inches apart. "
        }, 
      
        {
            step:'https://www.foldnfly.com/data/46/final.webp',
            stepDesc:"Use a bit of tape or a staple to keep the body from opening up. Then use the flaps that you cut to adjust the flight of your paper airplane to get it to fly a loop. If it doesn't loop, bend the flaps up. If the loop is too tight, bend the flaps down."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/46/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/46/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/46/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Wedge Plane',
     imageFilename:'wedgeplanefull.webp',
     airoplane:'wedgeplane.png',
     shortInfo:'This paper airplane can fly a big loop-the-loop in the air and keep flying.',
     longInfo:'This is a decent glider that we have turned into an acrobatic vertical loop flying paper plane.',
     difficulty: 'Medium',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/47/1.webp',
            stepDesc:'1. Fold the sheet in half.'
        },
        {
            step:'https://www.foldnfly.com/data/47/2.webp',
            stepDesc:"2. Open the sheet back up and fold the upper corners to the center."
        },
        {
            step:'https://www.foldnfly.com/data/47/3.webp',
            stepDesc:"3. Repeat the last step with the both upper edges."
        },
        {
            step:'https://www.foldnfly.com/data/47/4.webp',
            stepDesc:'4. Repeat again by folding the corners in'
        },
        {
            step:'https://www.foldnfly.com/data/47/5.webp',
            stepDesc:'5. Unfold everything back to step 2 and then fold the corners to the diagonal crease that you just made.'
        },
        {
            step:'https://www.foldnfly.com/data/47/6.webp',
            stepDesc:'6. Fold along this same crease again so the two halves cross over a bit in the middle.'
        },
        {
            step:'https://www.foldnfly.com/data/47/7.jpg',
            stepDesc:"7. Fold out the overlapping bits in the middle so that they meet in the center. This is the part that you will hold."
        },
        
      
        {
            step:'https://www.foldnfly.com/data/47/final.webp',
            stepDesc:"Use some tape on the place that you hold to keep it from falling apart, but don't tape the body flat. You want it to look like a wedge or cone flying through the air."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/47/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/47/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/47/print_sample_2.png"
        },
     ]
    },
    {
     name: 'Fast Glider',
     imageFilename:'fastgliderfull.webp',
     airoplane:'fastglider.png',
     shortInfo:'A realistic paper airplane that looks like a real airplane.',
     longInfo:'The separate wing and tail sections make this one of the more realistic designs. It flies and glides well too!',
     difficulty: 'Medium',
     distance: 'distance,time aloft',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/48/1.webp',
            stepDesc:'1. Fold the sheet in half, unfold and then fold the top two corners to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/48/2.webp',
            stepDesc:"2. Fold the top point down to meet the edge of the previous folds."
        },
        {
            step:'https://www.foldnfly.com/data/48/3.webp',
            stepDesc:"3. Fold the top two edges in to the center."
        },
        {
            step:'https://www.foldnfly.com/data/48/4.webp',
            stepDesc:'4. Fold the top point down to the bottom edge.'
        },
        {
            step:'https://www.foldnfly.com/data/48/5.webp',
            stepDesc:'5. Next, fold the point back up as shown. The doubled over part should be about 1 inch tall.'
        },
        {
            step:'https://www.foldnfly.com/data/48/6.webp',
            stepDesc:'6. Fold the plane in half and grab a pair of scissors.'
        },
        {
            step:'https://www.foldnfly.com/data/48/7.jpg',
            stepDesc:"7. Cut along the lines indicated in the picture, or in our downloadable instructions."
        },
        {
            step:'https://www.foldnfly.com/data/48/8.jpg',
            stepDesc:"8. Fold the wings out. The body will be about 1.25 inches tall."
        },
        {
            step:'https://www.foldnfly.com/data/48/9.jpg',
            stepDesc:"9. Finally, fold up the wing tips on the back set of wings."
        },
        
      
        {
            step:'https://www.foldnfly.com/data/48/final.webp',
            stepDesc:"Because this paper airplane has distinct wings that are separate from the tail, its one of the few designs that can use ailerons instead of elevons to steer the airplane."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/48/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/48/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/48/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Arrow',
     imageFilename:'thearrowfull.webp',
     airoplane:'thearrow.png',
     shortInfo:'A fast paper airplane that goes straight like an arrow.',
     longInfo:'Difficult to fold, but worth the effort for this fast flying dart.',
     difficulty: 'Expert',
     distance: 'distance',
     icon:'scissors',
     instructions:[
        {
            step:'https://www.foldnfly.com/data/49/1.webp',
            stepDesc:'1. Fold the sheet in half and then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/49/2.webp',
            stepDesc:"2. Fold the top right corner so that you make a crease going from the center top to the bottom right corner. Unfold."
        },
        {
            step:'https://www.foldnfly.com/data/49/3.webp',
            stepDesc:"3. Fold the right corner down to the crease of the previous fold and then refold that original fold."
        },
        {
            step:'https://www.foldnfly.com/data/49/4.webp',
            stepDesc:'4. Repeat step two and three with the left side.'
        },
        {
            step:'https://www.foldnfly.com/data/49/5.webp',
            stepDesc:'5. Next, fold the top point down to the bottom.'
        },
        {
            step:'https://www.foldnfly.com/data/49/6.webp',
            stepDesc:'6. Next, fold the top point back up as shown. The doubled over part should be just under 1 inch tall.'
        },
        {
            step:'https://www.foldnfly.com/data/49/7.jpg',
            stepDesc:"7. Fold the plane in half and then temporarily unfold."
        },
        {
            step:'https://www.foldnfly.com/data/49/8.jpg',
            stepDesc:"8. Fold in the right side of the plane, just the top part."
        },
        {
            step:'https://www.foldnfly.com/data/49/9.jpg',
            stepDesc:"9. Now, fold the right side back out and then invert fold the small triangle in the center."
        },
        {
            step:'https://www.foldnfly.com/data/49/10.jpg',
            stepDesc:"10. Repeat the last two steps with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/49/11.jpg',
            stepDesc:"11. Hold the wings together and cut out a piece to make the shape above. Download our printable instructions for an easy template."
        },
        {
            step:'https://www.foldnfly.com/data/49/12.jpg',
            stepDesc:"12. Finally, refold the body and wings and cut some tail fins to make fine adjustments."
        },
        
      
        {
            step:'https://www.foldnfly.com/data/49/final.webp',
            stepDesc:"Use a small piece of tape to keep the front part together and make small adjustments to the fins if necessary for level flight. Throw at about 45 degrees with full force for the longest flights."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/49/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/49/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/49/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Raven',
     imageFilename:'theravenfull.webp',
     airoplane:'theraven.png',
     shortInfo:'This easy paper airplane flies swiftly through the air in big circles.',
     longInfo:'Like a bird with wide wings, this airplane will circle around before landing.',
     difficulty: 'Easy',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/50/1.webp',
            stepDesc:'1. Fold the sheet in half and then unfold.'
        },
        {
            step:'https://www.foldnfly.com/data/50/2.webp',
            stepDesc:"2. Fold the top two corner to the center."
        },
        {
            step:'https://www.foldnfly.com/data/50/3.webp',
            stepDesc:"3. Again, fold the top two edges to the center."
        },
        {
            step:'https://www.foldnfly.com/data/50/4.webp',
            stepDesc:"4. Next, fold the top point down. You can fold it all the way to the bottom, or shy by a little bit. It's up to you!"
        },
        {
            step:'https://www.foldnfly.com/data/50/5.webp',
            stepDesc:'5. Fold the top two corners to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/50/6.webp',
            stepDesc:'6. It should now look like this.'
        },
        {
            step:'https://www.foldnfly.com/data/50/7.jpg',
            stepDesc:"7. Fold the triangle shaped flap in the center to meet the point of the airplane."
        },
        {
            step:'https://www.foldnfly.com/data/50/8.jpg',
            stepDesc:"8. Fold the plane in half down the middle."
        },
        {
            step:'https://www.foldnfly.com/data/50/9.jpg',
            stepDesc:"9. Finally, fold out the two wings."
        },
        {
            step:'https://www.foldnfly.com/data/50/final.webp',
            stepDesc:"The thickness of the layers of paper sometimes causes the front to rip a little, creating a cluster of three points. Thats ok!"
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/50/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/50/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/50/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Trooper',
     imageFilename:'thetrooper.webp',
     airoplane:'thetrooper.png',
     shortInfo:'A compact and realistic looking paper airplane that resembles a fighter jet.',
     longInfo:'This small dart like paper plane is a great long-distance flyer.',
     difficulty: 'Medium',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/51/1.webp',
            stepDesc:'1. Holding the paper vertically, fold the top down to the bottom and then fold it in half again from left to right.'
        },
        {
            step:'https://www.foldnfly.com/data/51/2.webp',
            stepDesc:"2. Unfold the horizontal fold and then fold the top two corners to the center."
        },
        {
            step:'https://www.foldnfly.com/data/51/3.webp',
            stepDesc:"3. Unfold all the way and then accordion fold the sides in."
        },
        {
            step:'https://www.foldnfly.com/data/51/4.webp',
            stepDesc:"4. Fold the top layer of the right flap all the way over to the left side. Then take the remaining flap on the right side and fold it to the center."
        },
        {
            step:'https://www.foldnfly.com/data/51/5.webp',
            stepDesc:'5. There are 3 layers on the left now. Grab the top layer and fold to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/51/6.webp',
            stepDesc:'6. Take these two folded flaps and fold them up in opposite directions as shown.'
        },
        {
            step:'https://www.foldnfly.com/data/51/7.jpg',
            stepDesc:"7. Repeat steps 4 and 5 with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/51/8.jpg',
            stepDesc:"8. Now fold the flaps up in opposite directions, like in step 6."
        },
        {
            step:'https://www.foldnfly.com/data/51/9.jpg',
            stepDesc:"9. Fold the airplane in half."
        },
        {
            step:'https://www.foldnfly.com/data/51/10.jpg',
            stepDesc:"10. Fold the wings out as shown. The edge of the front part of the wing should touch the bottom of the body of the airplane."
        },
        {
            step:'https://www.foldnfly.com/data/51/11.jpg',
            stepDesc:"11. Finally, fold the top layer of wings up."
        },
        {
            step:'https://www.foldnfly.com/data/51/final.webp',
            stepDesc:"Use a tiny bit of tape to keep the paper airplane together while flying. For maximum distance, throw as hard as you can at a 45 degree upward angle."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/51/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/51/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/51/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Horizon',
     imageFilename:'thehorizon.webp',
     airoplane:'thehorizon.png',
     shortInfo:'A great gliding paper airplane that can soar for many meters.',
     longInfo:'This reliable design likes to stay up in the air and fly for a long long ways.',
     difficulty: 'Expert',
     distance: 'distance',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/52/1.webp',
            stepDesc:'1. Fold the paper in half vertically. Unfold and then fold the top two corners to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/52/2.webp',
            stepDesc:"2. Fold the top point down to the bottom edge."
        },
        {
            step:'https://www.foldnfly.com/data/52/3.webp',
            stepDesc:"3. Fold the point back up, even with the bottom of the triangle flaps, about 3cm of overlap."
        },
        {
            step:'https://www.foldnfly.com/data/52/4.webp',
            stepDesc:"4. Fold the top part of right side to the center and then take the bottom part of the right side and stretch it to the side and flatten it out. Repeat with the left side."
        },
        {
            step:'https://www.foldnfly.com/data/52/5.webp',
            stepDesc:'5. Reach inside and pull out the center flaps. Then refold them in the opposite direction and fold the sides in.'
        },
        {
            step:'https://www.foldnfly.com/data/52/6.webp',
            stepDesc:'6. Take the bottom edge of each center flap and fold it backwards at a slight angle and then tuck under and press flat.'
        },
        {
            step:'https://www.foldnfly.com/data/52/7.jpg',
            stepDesc:"7. Fold the outer points of the top triangle shape to the center."
        },
        {
            step:'https://www.foldnfly.com/data/52/8.jpg',
            stepDesc:"8. Fold the airplane in half towards you."
        },
        {
            step:'https://www.foldnfly.com/data/52/9.jpg',
            stepDesc:"9. Fold out both wings as shown. The body should taper back from a point to about 4cm at the tail."
        },
        {
            step:'https://www.foldnfly.com/data/52/10.jpg',
            stepDesc:"10. Fold out one of the inner flaps at the front (where the cockpit is) and then fold it over the second flap to lock it in place."
        },
        {
            step:'https://www.foldnfly.com/data/52/11.jpg',
            stepDesc:"11. Finally, fold up the outer edges of the wings."
        },
        {
            step:'https://www.foldnfly.com/data/52/final.webp',
            stepDesc:"Put a staple in the body of the airplane near the center of mass to keep the fuselage tightly together. Throw as hard as you want at a slight upward angle and this paper airplane design will fly to the horizon."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/52/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/52/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/52/print_sample_2.png"
        },
     ]
    },
    {
     name: 'The Wilson',
     imageFilename:'thewilson.webp',
     airoplane:'thewilson.png',
     shortInfo:'A skinny paper airplane that flies fast and twists in mid-air.',
     longInfo:'This design has a tight and narrow nose with wings that flair out in the back.',
     difficulty: 'Easy',
     distance: 'distance,acrobatic',
     icon:"noscissors",
     instructions:[
        {
            step:'https://www.foldnfly.com/data/53/1.webp',
            stepDesc:'1. Fold the sheet in half, unfold and then fold the top two corners to the center.'
        },
        {
            step:'https://www.foldnfly.com/data/53/2.webp',
            stepDesc:"2. Fold the top two edges to the center."
        },
        {
            step:'https://www.foldnfly.com/data/53/3.webp',
            stepDesc:"3. Again, fold both outer edges to the center."
        },
        {
            step:'https://www.foldnfly.com/data/53/4.webp',
            stepDesc:"4. Grab the right center flap and fold it out, as shown."
        },
        {
            step:'https://www.foldnfly.com/data/53/5.webp',
            stepDesc:'5. Repeat with the left center flap.'
        },
        {
            step:'https://www.foldnfly.com/data/53/6.webp',
            stepDesc:'6. Fold the plane in half.'
        },
        {
            step:'https://www.foldnfly.com/data/53/7.jpg',
            stepDesc:"7. Finally, fold out both wings so the body is about 1cm tall from front to back."
        },
        {
            step:'https://www.foldnfly.com/data/53/final.webp',
            stepDesc:"Use a staple near the center of mass to keep the body together while flying. It will probably spin during flight. If you don't like this, make sure the wings are perfectly symmetrical and bent at the same angle. You can use small adjustments to the back of the wings to eliminate the spinning."
        },
     ],
      downloadprint:[
        {
            print:"https://www.foldnfly.com/data/53/print_sample_0.png"
        },
        {
            print:"https://www.foldnfly.com/data/53/print_sample_1.png"
        },
        {
            print:"https://www.foldnfly.com/data/53/print_sample_2.png"
        },
     ]
    },
]
